import "../models/verify_id_answer.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Collections ??= {};

AppointmentBooking.Wizard.Collections.VerifyIdAnswers = class VerifyIdAnswers extends Backbone.Collection {
  comparator(answer) {
    return answer.get("id");
  }
}; // Ensure answers are returned in the correct order
AppointmentBooking.Wizard.Collections.VerifyIdAnswers.prototype.model = AppointmentBooking.Wizard.Models.VerifyIdAnswer;
